import type { User } from '@/types'

/**
 * 登录态权限码集合。
 *
 * null = 登录态未提供权限列表（如平台侧账号），视为不限制；
 * 空集合 = 有权限列表但为空（该角色未勾任何页面）。
 */
export function resolveUserPermissions(user: User | null): Set<string> | null {
  if (!user) {
    return null
  }

  if (Array.isArray(user.permissions)) {
    return new Set(user.permissions)
  }

  return new Set()
}
